export default __webpack_public_path__ + "static/media/EHO logo-01.6eda2855.svg";